
import React from 'react';



type Props = {
  className?: string;
}
export const ServiceRestAPIVector: React.FC<Props> = ({ className }) => {
  return (
    <svg className = { className } width = '20' height = '20' viewBox = '0 0 20 20' fill = 'none' xmlns = 'http://www.w3.org/2000/svg'>
      <path fill = 'white' d = 'M12.6667 7.83333H7.33333V13.1667H12.6667V7.83333ZM10.8889 11.3889H9.11111V9.61111H10.8889V11.3889ZM18 9.61111V7.83333H16.2222V6.05556C16.2222 5.07778 15.4222 4.27778 14.4444 4.27778H12.6667V2.5H10.8889V4.27778H9.11111V2.5H7.33333V4.27778H5.55556C4.57778 4.27778 3.77778 5.07778 3.77778 6.05556V7.83333H2V9.61111H3.77778V11.3889H2V13.1667H3.77778V14.9444C3.77778 15.9222 4.57778 16.7222 5.55556 16.7222H7.33333V18.5H9.11111V16.7222H10.8889V18.5H12.6667V16.7222H14.4444C15.4222 16.7222 16.2222 15.9222 16.2222 14.9444V13.1667H18V11.3889H16.2222V9.61111H18ZM14.4444 14.9444H5.55556V6.05556H14.4444V14.9444Z' />
    </svg>
  );
};
